const order_tracking_banner_app = 'https://media.synctrack.io/megamind-estimated/asset/banner/banner_ordertracking.png';
const order_tracking_app = 'https://media.synctrack.io/megamind-assets/assets/logo_ordertracking.png';
const return_drive_banner_app = 'https://media.synctrack.io/megamind-estimated/asset/banner/banner_return.png';
const banner_lifetime = 'https://media.synctrack.io/megamind-estimated/asset/banner/banner_lifetime.png';
const return_drive_app = 'https://media.synctrack.io/megamind-assets/assets/logo_return.png';
const dashboard = 'https://media.synctrack.io/megamind-estimated/asset/images/dashboard.png';
const dashboardEstimated = 'https://media.synctrack.io/megamind-estimated/asset/images/dashboard_estimated.png';
const blockify = 'https://media.synctrack.io/megamind-estimated/asset/images/banner_checkout.png';
const synctrack_logo = 'https://media.synctrack.io/megamind-assets/assets/logo_synctrack.png';
const synctrack_banner = 'https://media.synctrack.io/megamind-estimated/asset/images/banner_synctrack.png';
const embed_gif = 'https://media.synctrack.io/megamind-estimated/asset/images/onboarding_embed.gif';
const emptyState = 'https://media.synctrack.io/megamind-estimated/asset/images/emptystate-files.avif';
const product = 'https://media.synctrack.io/megamind-estimated/asset/images/preview_productlineitem_setup.webp';
const preview_product = 'https://media.synctrack.io/megamind-estimated/asset/images/preview_product.png';
const demo_product = 'https://media.synctrack.io/megamind-estimated/asset/images/demo%20product.png';
const demo_estimated_text_cart = 'https://media.synctrack.io/megamind-estimated/asset/images/demo_estimated_text_cart.png';
const home_empty_state = 'https://media.synctrack.io/megamind-estimated/asset/images/home_empty_state.png';
const banner_discount = 'https://media.synctrack.io/megamind-estimated/asset/images/discount-banner.webp';
const empty_delivery_method = 'https://media.synctrack.io/megamind-estimated/asset/images/empty_delivery-min.png';
const empty_zipcode = 'https://media.synctrack.io/megamind-estimated/asset/images/empty_postal-min.png';
const empty_country = 'https://media.synctrack.io/megamind-estimated/asset/images/empty_country-min.png';
const empty_specific_rule = 'https://media.synctrack.io/megamind-estimated/asset/images/empty_specific-min.png';
const emptySearch = 'https://media.synctrack.io/megamind-estimated/asset/images/empty.webp';
const countryInBtn = 'https://media.synctrack.io/megamind-estimated/asset/images/location_country.png';
const zipcodeInBtn = 'https://media.synctrack.io/megamind-estimated/asset/images/location_zipcode.png';
const regionInBtn = 'https://media.synctrack.io/megamind-estimated/asset/images/location_state.png';
const emptyDataAnalytics = 'https://media.synctrack.io/megamind-estimated/asset/images/empty_analyticstable.png';
const trial_15days = 'https://media.synctrack.io/megamind-estimated/asset/banner_trial.png';
const popup_trial_15days = 'https://media.synctrack.io/megamind-estimated/asset/popup_trial_pro.png';
const popup_trial_15days_plus = 'https://media.synctrack.io/megamind-estimated/asset/popup_trial_plus.png';
// onboarding
const welcome = 'https://media.synctrack.io/megamind-estimated/asset/images/onboarding_welcome.webp';
const onboarding_demo_page = 'https://media.synctrack.io/megamind-estimated/asset/images/onboarding_demo_page.png';
const onboarding_finish = 'https://media.synctrack.io/megamind-estimated/asset/images/onboarding_finish.webp';
const onboarding_country = 'https://media.synctrack.io/megamind-estimated/asset/images/onboarding_country.png';
const onboarding_zipcode = 'https://media.synctrack.io/megamind-estimated/asset/images/onboarding_zipcode.png';
const onboarding_state = 'https://media.synctrack.io/megamind-estimated/asset/images/onboarding_state.png';
const blank = 'https://media.synctrack.io/megamind-estimated/asset/images/blank.png';
const basic_method = 'https://media.synctrack.io/megamind-estimated/asset/images/basic_method.png';
const basic_zipcode = 'https://media.synctrack.io/megamind-estimated/asset/images/basic_zipcode.png';
const basic_country = 'https://media.synctrack.io/megamind-estimated/asset/images/basic_country.png';
const advanced_method = 'https://media.synctrack.io/megamind-estimated/asset/images/advanced_method.png';
const advanced_zipcode = 'https://media.synctrack.io/megamind-estimated/asset/images/advanced_zipcode.png';
const advanced_country = 'https://media.synctrack.io/megamind-estimated/asset/images/advanced_country.png';
const chooseCheckoutRule = 'https://media.synctrack.io/megamind-estimated/asset/images/onboarding_plus_choose_checkout.png';
const chooseSFRule = 'https://media.synctrack.io/megamind-estimated/asset/images/onboarding_plus_choose_storefront.png';
const addCheckoutApp = 'https://media.synctrack.io/megamind-estimated/asset/images/checkoutblock.webp';

//checklist setup
const checkout = 'https://media.synctrack.io/megamind-estimated/asset/images/showcart_preview1.png';
const checkoutSetting = 'https://media.synctrack.io/megamind-estimated/asset/images/showcart_preview2.png';

//checkout page
const demoPreviewCheckout = 'https://media.synctrack.io/megamind-estimated/asset/images/preview_checkout-min.png';
const emptyCheckout = 'https://media.synctrack.io/megamind-estimated/asset/images/empty_checkout-min.png';
const demoPreviewThankyouOrder = 'https://media.synctrack.io/megamind-estimated/asset/images/preview_tyos.webp';
const feedback = 'https://media.synctrack.io/megamind-estimated/asset/images/feedback.webp';
const checkoutBlockGuide = 'https://media.synctrack.io/megamind-estimated/asset/images/checkoutblock.webp';
const previewProductLineItems = 'https://media.synctrack.io/megamind-estimated/asset/images/preview_productlineitems.webp';
const thumbnailCheckoutExtension = 'https://media.synctrack.io/megamind-estimated/asset/images/thumbnail_etacheckout.png';

//home page
const etaCheckout = 'https://media.synctrack.io/megamind-estimated/whatsnew_checkout.png';
const newEDD = 'https://media.synctrack.io/megamind-estimated/whatsnew_newrulesetup.png';
const newRuleByVariant = 'https://media.synctrack.io/megamind-estimated/whatsnew_variant.png';
const newOutOfStock = 'https://media.synctrack.io/megamind-estimated/whatsnew_oos.png';
const pareto = 'https://media.synctrack.io/megamind-estimated/asset/images/banner_pareto_est.png';

// pricing page
const pricing_banner = 'https://media.synctrack.io/megamind-estimated/pricing_free.png';

// translation page
const noRuleSelected = 'https://media.synctrack.io/megamind-estimated/asset/images/empty_language_addrule.png';
const emptyTranslation = 'https://media.synctrack.io/megamind-estimated/asset/images/empty_language.png';

export const images = {
  addCheckoutApp,
  chooseSFRule,
  chooseCheckoutRule,
  noRuleSelected,
  emptyTranslation,
  countryInBtn,
  zipcodeInBtn,
  regionInBtn,
  pareto,
  newEDD,
  newRuleByVariant,
  newOutOfStock,
  thumbnailCheckoutExtension,
  etaCheckout,
  dashboard,
  dashboardEstimated,
  blockify,
  order_tracking_banner_app,
  order_tracking_app,
  return_drive_banner_app,
  return_drive_app,
  welcome,
  synctrack_logo,
  synctrack_banner,
  embed_gif,
  onboarding_demo_page,
  onboarding_finish,
  emptyState,
  product,
  preview_product,
  demo_product,
  onboarding_country,
  onboarding_zipcode,
  onboarding_state,
  blank,
  basic_method,
  basic_zipcode,
  basic_country,
  advanced_method,
  advanced_zipcode,
  advanced_country,
  demo_estimated_text_cart,
  home_empty_state,
  banner_discount,
  checkout,
  checkoutSetting,
  empty_delivery_method,
  empty_zipcode,
  empty_country,
  empty_specific_rule,
  emptySearch,
  demoPreviewCheckout,
  emptyCheckout,
  demoPreviewThankyouOrder,
  feedback,
  checkoutBlockGuide,
  previewProductLineItems,
  pricing_banner,
  trial_15days,
  popup_trial_15days,
  popup_trial_15days_plus,
  emptyDataAnalytics,
  banner_lifetime,
};
